import { onMount, onDestroy, onView } from '@/modules/_'

export default function (element, dataset) {
  const text = element.querySelector('.slot > div')
  const targetValue = parseFloat(text.textContent)
  const counter = { value: 0 }

  onView(element, {
    autoStart: true,
    callback: ({ isIn }) => {
      if (isIn) {
        gsap.to(counter, {
          value: targetValue,
          duration: 1,
          ease: 'power2.out',
          onUpdate: function () {
            text.textContent = Math.round(counter.value) + '%'
          },
        })
      }
    },
  })
}
